import React, {useState} from "react";
import {db} from "../firebase";
import {collection, addDoc} from "firebase/firestore";
import "../style/apply-form.css";

declare global {
  interface Window {
    wcs?: any;
    wcs_add?: any;
  }
}
export {};


function formatPhoneNumber(text: string): string {
  const isSeoulNZ = text.slice(0, 2) === "02";
  const nationZoneRgex = isSeoulNZ ? "(\\d{1,2})" : "(\\d{1,3})";
  const phonePattern = new RegExp(`^${nationZoneRgex}(\\d{0,4})(\\d{0,4}).*$`);

  return text
    .replace(/[^0-9]/g, "")
    .replace(phonePattern, "$1-$2-$3")
    .replace(/^-/, "")
    .replace(/-$/, "")
    .replace(/-$/, "");
}

const ApplyForm: React.FC = () => {
  const [registerName, setRegisterName] = useState("");
  const [studentName, setStudentName] = useState("");
  const [phone, setPhone] = useState("");
  const [age, setAge] = useState("");
  const [skill, setSkill] = useState("");
  const [rental, setRental] = useState(true);
  const [date, setDate] = useState("");
  const [etc, setEtc] = useState("");

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (
      !registerName ||
      !studentName ||
      !phone ||
      !age ||
      !skill ||
      !date
    ) {
      alert("모든 필드를 작성해주세요.");
      return;
    }

    if (registerName.length > 8 || studentName.length > 8) {
      alert("등록자 이름과 학생 이름은 최대 8글자까지 가능합니다.");
      return;
    }

    if (date.length > 500 || etc.length > 500) {
      alert("날짜와 기타 정보는 최대 500자까지 가능합니다.");
      return;
    }

    try {
      const applyCollection = collection(db, "apply");
      await addDoc(applyCollection, {
        register_name: registerName,
        student_name: studentName,
        phone,
        age: Number(age),
        skill,
        rental,
        date,
        etc,
        checked: false,
        memo: "",
        createdAt: Date.now(),
      });
      // ✅ NAVER 신청완료(lead) 트래킹
      if (window.wcs) {
        window.wcs_add = window.wcs_add || {};
        window.wcs_add["wa"] = "s_23a19b38cc26";
        window.wcs.trans({type: "lead"});
      } else {
        console.warn("NAVER wcslog.js not loaded yet.");
      }
      alert("신청이 완료되었습니다!");
      setRegisterName("");
      setStudentName("");
      setPhone("");
      setAge("");
      setSkill("");
      setRental(false);
      setDate("");
      setEtc("");
    } catch (error) {
      console.error("저장 중 오류 발생:", error);
      alert("저장 중 오류가 발생했습니다.");
    }
  };

  return (
    <form className={'apply-form'} onSubmit={handleSubmit}>
      <div className={'apply-form-frame'}>
        <div className={'apply-form-title'}>
          예약자(입금자) 정보
        </div>
        <div className={'apply-form-holder-fields'}>
          <div className={'apply-form-field'}>
            <label className={'apply-form-label'}>성함</label>
            <input
              className={'apply-form-input'}
              type="text"
              value={registerName}
              onChange={(e) => setRegisterName(e.target.value)}
              maxLength={8}
              placeholder={"예약자명 또는 입금자명"}
              required
            />
          </div>
          <div className={'apply-form-field'}>
            <label className={'apply-form-label'}>전화번호</label>
            <input
              className={'apply-form-input'}
              type="text"
              value={formatPhoneNumber(phone)}
              onChange={(e) => setPhone(e.target.value.replace(/[^0-9]/g, ""))}
              required
              placeholder={"숫자만 입력해주세요. ex) 01012345678"}
            />
          </div>
        </div>
      </div>
      <div className={'apply-form-frame'}>
        <div className={'apply-form-title'}>
          강습자 정보
        </div>
        <div className={'apply-form-holder-fields'}>
          <div className={'apply-form-field'}>
            <label className={'apply-form-label'}>성함</label>
            <input
              className={'apply-form-input'}
              type="text"
              value={studentName}
              onChange={(e) => setStudentName(e.target.value)}
              maxLength={8}
              placeholder={"강습 받으실 분의 성함"}
              required
            />
          </div>
          <div className={'apply-form-field'}>
            <label className={'apply-form-label'}>나이(만)</label>
            <input
              className={'apply-form-input'}
              type="number"
              value={age}
              onChange={(e) => setAge(e.target.value ? parseInt(e.target.value, 10).toString() : "")}
              placeholder={"만 00세"}
              required
            />
          </div>
          <div className={'apply-form-field'}>
            <label className={'apply-form-label'}>실력</label>
            <select
              className={'apply-form-input'}
              value={skill} onChange={(e) => setSkill(e.target.value)} required>
              <option value="" disabled>
                선택하세요
              </option>
              {["최상", "상", "중상", "중", "중하", "하", "최하"].map((level) => (
                <option key={level} value={level}>
                  {level}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className={'apply-form-field m-col'}>
          <label className={'apply-form-label'}>렌탈 필요 여부 (스키와 부츠)</label>
          <div className={'apply-form-checkbox-frame'}>
            <div className={'apply-form-checkbox'}
                 onClick={() => setRental(true)}>
              <input
                className={'apply-form-radio-button'}
                type="radio"
                checked={rental}
                readOnly={true}
              />
              네, 필요합니다
            </div>
            <div className={'apply-form-checkbox'}
                 onClick={() => setRental(false)}>
              <input
                type="radio"
                checked={!rental}
                readOnly={true}
              />
              아니오, 괜찮습니다
            </div>
          </div>
        </div>
        <div className={'apply-form-field m-col'} style={{alignItems: 'flex-start'}}>
          <label className={'apply-form-label'}
                 style={{marginTop: '8px', minWidth: '120px'}}>강습 시간 및 날짜 <br/> 원하는
            시간</label>
          <textarea
            style={{maxWidth: '100%'}}
            className={'apply-form-input textarea'}
            value={date}
            onChange={(e) => setDate(e.target.value)}
            maxLength={500}
            required
          />
        </div>
        <div className={'apply-form-field m-col'} style={{alignItems: 'flex-start'}}>
          <label className={'apply-form-label'}
                 style={{marginTop: '8px', minWidth: '120px'}}>기타 문의사항</label>
          <textarea
            className={'apply-form-input textarea'}
            value={etc}
            onChange={(e) => setEtc(e.target.value)}
            maxLength={500}
          />
        </div>
      </div>
      <button className={'apply-form-button'} type="submit">신청 등록</button>
    </form>
  )
};

export default ApplyForm;
